import { getApiClient } from '@aslanpay/portal-common-lib';

import {
  CLIENT_PORTAL_ORIGIN,
  EMPLOYEE_PORTAL_ORIGIN,
  getActiveLoginContext,
} from 'app/constants/authentication';

/**
 * Overrides x-aslan-origin per request to reflect which identity is currently active, so
 * RecognitionAuditSource can distinguish an employee's actions from an admin's - otherwise
 * indistinguishable, since both share this one client app and its default origin header.
 *
 * Only touches requests still carrying the plain default (CLIENT_PORTAL_ORIGIN) - a request that
 * explicitly set a different origin (the switch flow's pre-auth check-email/verify-email calls,
 * which must resolve EMPLOYEE_PORTAL_ORIGIN regardless of the still-ADMIN active context mid-switch)
 * is left untouched.
 */
export const applyActiveContextOrigin = () => {
  getApiClient().interceptors.request.use((config) => {
    if (config.headers.get('x-aslan-origin') === CLIENT_PORTAL_ORIGIN) {
      config.headers.set(
        'x-aslan-origin',
        getActiveLoginContext() === 'EMPLOYEE' ? EMPLOYEE_PORTAL_ORIGIN : CLIENT_PORTAL_ORIGIN
      );
    }
    return config;
  });
};
